import axios from '../assets/axios'
export default {
  namespaced: true,

  state: {
    protocolList: [] // 协议列表
  },

  mutations: {
    setProtocolList (state, list) {
      state.protocolList = list
    }
  },

  actions: {
    getProtocolList: ({ commit }, params) => {
      return axios.post('/cashloan/v1/users/protocols/withdraw', params)
        .then(response => {
          if (response.data.code === 'OK') {
            commit('setProtocolList', response.data.data)
          }
          return response.data
        })
    }
  }
}